module.exports = __webpack_public_path__ + "static/img/24.8effb61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/24.png
// module id = ykFB
// module chunks = 1